import React, { ReactNode } from 'react'

import { theme } from '@hhgtech/hhg-components'
import { Title, Text } from '@mantine/core'
import dayjs from 'dayjs'
import { useIntl } from 'react-intl'

import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { DATE_FORMAT_BY_LOCALE } from 'interfaces/constants/pregenancyCategory'

import { StyledHeading, StyledResultBanner } from './index.styled'

type ResultBannerProps = {
  currentWeek?: number
  dueDate?: Date
  articleLink?: string
}
const _ResultBanner = ({ currentWeek, dueDate }: ResultBannerProps) => {
  const { formatMessage: f } = useIntl()
  const isMobile = useIsMobile()
  const { locale } = useRouterExtend()

  if (!dueDate) return null
  return (
    <StyledResultBanner color={theme.colors.pink50}>
      <StyledHeading>
        <Title
          order={1}
          size={isMobile ? 20 : 26}
          color={theme.colors.gray800}
          className="max-w-[515px]"
        >
          {f({
            id: 'dueDatePage.banner.title',
            defaultMessage: 'Congratulations!',
          })}{' '}
          {f({ id: 'dueDatePage.dueDateResult' })}{' '}
          <Text color={theme.colors.pink800} span={true}>
            {dayjs(dueDate).format(DATE_FORMAT_BY_LOCALE[locale])}
          </Text>
        </Title>
        <Text
          size={isMobile ? 14 : 18}
          weight="normal"
          color={theme.colors.gray800}
        >
          {f(
            {
              id: 'dueDatePage.weekResult',
              defaultMessage: 'You are <week>weeks<week> pregnant.',
            },
            {
              week: function Component(chunks: ReactNode[]) {
                return (
                  <Text span color={theme.colors.gray800} weight="bold">
                    {currentWeek === 1
                      ? f({
                          id: 'childCard.age.oneWeek',
                          defaultMessage: '1 week',
                        })
                      : `${currentWeek} ${chunks}`}
                  </Text>
                )
              },
            },
          )}
        </Text>
      </StyledHeading>
    </StyledResultBanner>
  )
}

export const ResultBanner = React.memo(_ResultBanner)
